import React from 'react'

import DetailRow from './common/DetailRow'

import Fixed from './Fixed'
import Variable from './Variable'
import RateRowSplit from './common/RateRowSplit'

class Detail extends React.Component {

  renderVariable() {
    const {
      loanDetail: {
        interestType,
        variable: {
          variableRepaymentType,
        },
        settings,
        summary: {
          variableAmountLabel,
          variableRepaymentWithYear,
          variableRepaymentTypeLabel,
          offsetAccountLabel,
          overallLoanTermLabel,
        },
        calculator,
      },
    } = this.props

    return(
      <Variable
        loanAmountLabel={ variableAmountLabel }
        repaymentWithFrequency={ calculator.variable.displayableRepaymentLabelWithFrequency }
        interestTypeLabel={ settings.interestTypeLabel }
        rateLabel={ calculator['variable'].displayableRateLabel }
        repaymentType={ variableRepaymentType }
        repaymentWithYear={ variableRepaymentWithYear }
        repaymentTypeLabel={ variableRepaymentTypeLabel }
        overallLoanTermLabel={ overallLoanTermLabel }
        offsetAccountLabel={ offsetAccountLabel }
        futureRepayment={ calculator.variable.principalAndInterestRepaymentLabel }
      />
    )
  }

  renderFixed() {
    const {
      loanDetail: {
        interestType,
        fixed: {
          fixedRepaymentType,
        },
        settings,
        summary: {
          fixedAmountLabel,
          fixedInterestPeriodLabel,
          interestTypeLabel,
          fixedRepaymentTypeLabel,
          overallLoanTermLabel,
        },
        calculator,
      },
    } = this.props

    return(
      <Fixed
        loanAmountLabel={ fixedAmountLabel }
        repaymentWithFrequency={ calculator.fixed.displayableRepaymentLabelWithFrequency }
        fixedInterestPeriodLabel={ fixedInterestPeriodLabel }
        interestTypeLabel={ interestTypeLabel }
        rateLabel={ calculator['fixed'].displayableRateLabel }
        repaymentType={ fixedRepaymentType }
        repaymentTypeLabel={ fixedRepaymentTypeLabel }
        overallLoanTermLabel={ overallLoanTermLabel }
        futureRepayment={ calculator.fixed.principalAndInterestRepaymentLabel }
      />
    )
  }

  render() {
    const {
      loanDetail: {
        interestType,
      },
    } = this.props;

    return(
      <div>
        {
          (interestType == 'split') && (
            <div>
              <RateRowSplit title='Split 1 - Fixed' >
                { this.renderFixed() }
              </RateRowSplit>
              <RateRowSplit title='Split 2 - Variable' >
                { this.renderVariable() }
              </RateRowSplit>
            </div>
          )
        }

        {
          (interestType == 'fixed') && (
            this.renderFixed()
          )
        }

        {
          (interestType == 'variable') && (
            this.renderVariable()
          )
        }
      </div>
    )
  }
}

export default Detail
